import { SEO } from "@/components/seo/SEO";
const TermsAndConditions = () => {
  return (
    <>
      <SEO 
        title="Terms and Conditions | Careerfy"
        description="Read the Terms and Conditions for using Careerfy's AI-powered interview and resume services."
        path="/terms-and-conditions"
        structuredData={{
          "@context": "https://schema.org",
          "@type": "WebPage",
          name: "Terms and Conditions",
          url: "/terms-and-conditions"
        }}
      />
      <div className="max-w-4xl mx-auto px-4 py-16">
      <h1 className="text-title font-semantic-bold text-primary mb-8">Terms and Conditions</h1>
      
      <div className="space-y-6 text-gray-600">
        <section>
          <h2 className="text-header font-semantic-semibold text-primary mb-4">1. Agreement to Terms</h2>
          <p>By accessing and using Careerfy services provided by HeyLiving Club LLP, you agree to be bound by these Terms and Conditions. If you disagree with any part of these terms, you may not access our services.</p>
        </section>

        <section>
          <h2 className="text-header font-semantic-semibold text-primary mb-4">2. Description of Service</h2>
          <p>Careerfy provides AI-powered interview preparation and career development services, including but not limited to interview practice, resume analysis, and career guidance.</p>
        </section>

        <section>
          <h2 className="text-header font-semantic-semibold text-primary mb-4">3. User Accounts</h2>
          <p>Users must provide accurate and complete information when creating an account. You are responsible for maintaining the confidentiality of your account credentials.</p>
        </section>

        <section>
          <h2 className="text-header font-semantic-semibold text-primary mb-4">4. Service Usage</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>Users must not misuse our services or attempt to access them using unauthorized methods.</li>
            <li>Content uploaded must not violate any intellectual property rights.</li>
            <li>Users are responsible for all activity that occurs under their account.</li>
          </ul>
        </section>

        <section>
          <h2 className="text-header font-semantic-semibold text-primary mb-4">5. Payment Terms</h2>
          <p>Premium services require payment as per the pricing plans displayed on our website. All payments are processed securely through our payment gateway.</p>
        </section>

        <section>
          <h2 className="text-header font-semantic-semibold text-primary mb-4">6. Contact Information</h2>
          <p>For any queries regarding these terms, please contact us:</p>
          <ul className="list-none space-y-2 mt-2">
            <li>Company: HeyLiving Club LLP</li>
            <li>Email: Info@careerfy.ai</li>
            <li>Phone: +91 9552526258</li>
          </ul>
        </section>
      </div>
      </div>
    </>
  );
};

export default TermsAndConditions;
